import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { dateConvert } from "../../../utility/dateModifier";
import { profileDetailsService } from "../../../utility/services/profileDetailsService";
import BodyComponent from "../../components/BodyComponent";
import TopHeaderComponent from "../../components/TopHeaderComponent";
import ProfileContainer from "./ProfileContainer";

const Profile = ({ profileDetails }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    // console.log(profileDetails, "profileDetails");
    dispatch(profileDetailsService());
  }, []);
  return (
    <BodyComponent
      style={{
        width: "100%",
        marginLeft: "50px",
        paddingBottom: "50px",
        marginRight: "50px",
        //  backgroundColor:"red",
      }}
    >
      <TopHeaderComponent
        headerName="Profile"
        showDownload={false}
        showFilter={false}
      />
      {/* <TwoStepVerification /> */}

      <ProfileContainer
        header="Virtual Account Number"
        headerValue={profileDetails?.accountNumber}
        data={{
          "Status:": "ACTIVATED",
          "Name:": profileDetails?.firstName + " " + profileDetails?.lastName,
          "Email:": profileDetails?.emailId,
          "Mobile Number:": profileDetails?.mobileNumber,
          "Business Name:": profileDetails?.businessName,
          "Contact Email:": "support@neokred.tech",
          "Business Type:": profileDetails?.businessType,
          "Activated On:": dateConvert(profileDetails?.createdDate),
        }}
      />

      <ProfileContainer
        header="GST Details"
        data={{
          "GST Details:": profileDetails?.gstCertificate
            ? profileDetails?.gstCertificate
            : "N/A",
        }}
      />
    </BodyComponent>
  );
};

const mapStateToProps = (state) => {
  return {
    profileDetails: state.profileDetailsReducer.details,
  };
};
export default connect(mapStateToProps)(Profile);
